import { render } from "./InformeRentabilidadOperariosCompanyias.vue?vue&type=template&id=806413d8&scoped=true"
import script from "./InformeRentabilidadOperariosCompanyias.vue?vue&type=script&lang=js"
export * from "./InformeRentabilidadOperariosCompanyias.vue?vue&type=script&lang=js"

import "./InformeRentabilidadOperariosCompanyias.vue?vue&type=style&index=0&id=806413d8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806413d8"]])

export default __exports__